import { SumScopes } from "../models/Activities";
import {
  EmissionFactorDataV2,
  EmissionFactorPublisher,
} from "../models/EmissionFactors";
import { isScope3Open } from "../config/config";

export function calculateSumScopes(
  raw: SumScopes,
  includeS0 = true,
): SumScopes {
  const base = includeS0 ? raw.s0 : 0;
  const total = isScope3Open
    ? base + raw.s1 + raw.s2 + raw.s3
    : base + raw.s1 + raw.s2;

  return { ...raw, sum: total / 1000 };
}

// only these groups' upstream value lands in Scope 3 Cat 3; names match the backend's emissionGroup
const CAT3_UPSTREAM_GROUPS = ["Fuel", "Energy"];

export function showsCat3UpstreamHint(
  emissionGroup: string | undefined,
): boolean {
  return (
    isScope3Open &&
    !!emissionGroup &&
    CAT3_UPSTREAM_GROUPS.includes(emissionGroup)
  );
}

export function cat3UpstreamPublisher(
  emissionGroup: string | undefined,
  publisher: EmissionFactorPublisher | undefined,
): string | undefined {
  if (!showsCat3UpstreamHint(emissionGroup)) return undefined;
  const upstream = publisher?.upstreamPublisherRef;
  // a bare id string means the backend did not populate it, so there is no name to show
  if (!upstream || typeof upstream !== "object") return undefined;
  const name = upstream.publishReference;
  return typeof name === "string" && name !== "" ? name : undefined;
}

// looks up the factor by id, never by name, so a copy and its original each keep their own list
export function cat3UpstreamForFactor(
  factorGroups: EmissionFactorDataV2[] | undefined,
  factorId: string | undefined,
): string | undefined {
  if (!factorId) return undefined;
  for (const group of factorGroups ?? []) {
    const publisher = group.publishers?.find(
      (p) => p.emissionFactorRefId === factorId,
    );
    if (publisher) return cat3UpstreamPublisher(group.emissionGroup, publisher);
  }
  return undefined;
}
